module.exports = __webpack_public_path__ + "static/media/classroom-peoples-icon.f97baeae.svg";